import { PMenuActionsModule } from './../../actions/pmenu.actions.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { DossierActionsComponent } from './dossierActions.component';
import { TasksModule } from '../../tasks/tasks.module';
import { TableModule } from 'primeng-lts/table';
import { DirectivesModule } from '../../directives/directives.module';
import { DossierActionsListComponent } from './dossierActionsList.component';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { ActionsModule } from '../../actions/actions.module';
import { AccordionModule } from 'primeng-lts/accordion';
import { MenuModule } from 'primeng-lts/menu';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TabViewModule } from 'primeng-lts/tabview';
import { FieldsetModule } from 'primeng-lts/fieldset';
import { UserModule } from '../../user/user/user.module';
import { ButtonModule } from 'primeng-lts/button';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';


@NgModule({
  declarations: [DossierActionsComponent, DossierActionsListComponent],
  imports: [
    CommonModule,
    FormsModule,

    WaitLoadingModule,
    DynamicDialogModule,
    RouterModule,
    TableModule,
    TranslateModule,
    TasksModule,
    TabViewModule,
    DirectivesModule,
    SubHeaderModule,
    ScrollPanelModule,
    AccordionModule,
    FieldsetModule,
    MenuModule,
    UserModule,
    ActionsModule,
    PMenuActionsModule,
    ButtonModule,
    FormPlycaModule
  ]
})
export class DossierActionsModule { }
